<template>
   <div class="editor">
      <div class="editor__toolbar">
         <div class="button"></div>
         <div class="button"></div>
         <div class="button" style="margin-right: 7px"></div>
         {{title}}
      </div>
      <div class="editor__content" style="padding-top: 5px; padding-bottom: 5px">
         <template v-for="(line, index) in lines">
            <div class="editor__line line">
               <span class="line__number line__number--symbol">{{index+1}}</span>{{line}}
            </div>
         </template>
      </div>
   </div>
</template>
<script>
   export default {
      props: {
         lines: {
            type: Array,
            required: false,
            default: []
         },
         title: {
            type: String,
            required: false,
            default: ''
         }
      }
   }
</script>
<style>
   .editor {
      width: 100%;
      margin: 0;
      background-color: #2A2F34;
      border-radius: 5px;
      text-align: left;
   }

   .editor .editor__toolbar {
      padding: 6px 15px;
      color: white;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
   }

   .editor .editor__toolbar .button {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 2px;
      padding: 0;
      border-radius: 100%;
   }

   .editor .editor__toolbar .button:nth-child(1) {
      background-color: #ED7268;
   }

   .editor .editor__toolbar .button:nth-child(2) {
      background-color: #F9E600;
   }

   .editor .editor__toolbar .button:nth-child(3) {
      margin-right: 0;
      background-color: #4BD591;
   }

   .editor .editor__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px 15px 35px 15px;
      font-family: 'Menlo', 'Monaco', 'Courier New', monospace;
      font-size: 13px;
      overflow: auto;
      color: white;
   }

   .editor .editor__variable {
      color: rgb(193, 83, 236);
   }

   .editor .editor__element {
      color: #539EEC;
   }

   .editor .editor__value {
      color: #CE9079;
   }

   .editor .editor__comment {
      color: #6e7884;
   }

   .editor .editor__content .line {
      padding-right: 15px;
      line-height: 2.3;
      display: flex;
      margin-bottom: -3px;
   }

   .line .line__number {
      display: table-cell;
      width: 25px;
      color: white;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
   }

   .line .line__number.line__number--symbol {
      position: relative;
      margin-top: 7px;
      font-size: 13.3px;
      line-height: normal;
   }
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue